import { useState } from "react";
import { Empty } from "@/components/atlas/Shared";
import { EventCard, AvailabilityDialog, useAvailability } from "@/components/availability/EventCard";
import { ShiftCalendar, ViewSwitch } from "@/components/time/ShiftCalendar";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

export default function Available() {
  const { t } = useLang();
  const { user } = useAuth();
  const { data, onChange } = useAvailability();
  const [view, setView] = useState("list");
  const [openId, setOpenId] = useState(null);
  const answered = (data || []).filter((e) => e.my_availability).length;
  const opened = (data || []).find((e) => e.id === openId);

  return (
    <div>
      <div className="mb-8 rise">
        <p className="font-display text-3xl" data-testid="employee-greeting">{t("dash.greet")}, <span className="text-[#D9B872]">{user.name.split(" ")[0]}</span></p>
        <p className="text-xs text-neutral-500 mt-1 mb-6">{t("p.greetSub")}</p>
        <div className="eyebrow mb-2">{data ? `${answered}/${data.length} ${t("p.answered")}` : ""}</div>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="page-title">{t("p.availTitle")}</h1>
        <p className="text-sm text-neutral-500 mt-3">{t("p.availSub")}</p>
        <div className="mt-5"><ViewSwitch view={view} setView={setView} /></div>
      </div>
      {data && data.length === 0 && <Empty text={t("p.noEvents")} testid="available-empty" />}
      {view === "calendar" ? <ShiftCalendar events={(data || []).filter((e) => !e.assigned)} onOpen={(en) => setOpenId(en.x.id)} /> : (
        <div className="space-y-5" data-testid="available-events">
          {(data || []).map((e, i) => <EventCard key={e.id} e={e} i={i} onChange={onChange} />)}
        </div>
      )}
      <AvailabilityDialog event={opened} onClose={() => setOpenId(null)} onChange={onChange} />
    </div>
  );
}
